export const TAX_RATE_TYPE_BASIC = 1
export const TAX_RATE_TYPE_FIRST_REDUCED = 2
export const TAX_RATE_TYPE_SECOND_REDUCED = 3
export const TAX_RATE_TYPE_ZERO = 4